export default "__VITE_ASSET__B8fq0QrT__"